/**
 * Shared footer for all public (unauthenticated) pages.
 *
 * Renders copyright, site links, and legal links in a consistent layout.
 */

export default function PublicFooter() {
  return (
    <footer class="border-t border-slate-200/60 py-8">
      <div class="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 text-sm text-slate-500 sm:flex-row sm:px-6 lg:px-8">
        <p>&copy; {new Date().getFullYear()} Sammons Software LLC</p>
        <div class="flex flex-wrap justify-center gap-6">
          <a href="/guides" class="hover:text-slate-700">
            Guides
          </a>
          <a href="/docs" class="hover:text-slate-700">
            API Docs
          </a>
          <a href="/blog" class="hover:text-slate-700">
            Blog
          </a>
          <a href="https://status.webhookstorage.com" class="hover:text-slate-700" target="_blank" rel="noopener noreferrer">
            Status
          </a>
          <a href="/security" class="hover:text-slate-700">
            Security
          </a>
          <a href="/privacy" class="hover:text-slate-700">
            Privacy
          </a>
          <a href="/terms" class="hover:text-slate-700">
            Terms
          </a>
          <a href="/about" class="hover:text-slate-700">
            About
          </a>
        </div>
      </div>
    </footer>
  );
}
